import UICommunityResponse from '@/scripts/legacy-ui-library/ui-community-response';
import _ from 'underscore';
import moment from 'moment';
import Autolinker from 'autolinker';
import Ladda from 'ladda';
import twemoji from 'twemoji';

import 'dotdotdot';
import 'initial-js';

import UIHelper from '@/scripts/helpers/ui-helper';

import BrowserStorage from '@/scripts/helpers/browser-storage';
import loginController from '@/scripts/libs/login/controller';
import viddsee from '@/scripts/viddsee';
import webcall from '@/scripts/webcall';

const _question = {
  id: '',
  slug: '',
};
let parentCommentId = -1;
let targetCommentPos = -1;
let targetCommentId = -1;
const DEFAULT_REPLY_PER_PAGE = 10;
let me;

const _preInit = function _preInit() {
  if ($('#response').length !== 0) {
    return true;
  }
  return false;
};

const _initPageData = function _initPageData(callback) {
  _question.id = $('#response').data('question-id');
  _question.slug = $('#response').attr('data-question-slug');

  parentCommentId = $('div.response__content__text').data('comment-id');
  targetCommentPos = $('#target-comment-pos').data('target-comment-pos');
  targetCommentId = $('#target-comment-pos').data('target-comment-id');
  $('#comments__see-more').data('current-page', 0);

  if (BrowserStorage.getItem('access_token')) {
    webcall.user.get({}, (response) => {
      me = response;
      return (typeof (callback) === 'function') ? callback() : callback;
    });
  } else {
    return (typeof (callback) === 'function') ? callback() : callback;
  }
};

const _bindUIActions = function _bindUIActions() {
  const $parentComment = $('div.response__content');

  $parentComment.on('vs:app:community-response:comment:like', (e) => {
    _voteHandler(e);
  });

  $parentComment.on('click', '.comment__item__login', (e) => {
    e.preventDefault();
    ga('send', 'event', 'onboarding', 'comment-login');
    viddsee.ui.modal.register.open({
      callback: 'new_comment',
      loginReason: I18n.t('javascript.login-reason.common-community-interaction'),
    });
  });

  $parentComment.on('click', '.response__content__like--login', (e) => {
    e.preventDefault();
    ga('send', 'event', 'onboarding', 'comment-login');
    viddsee.ui.modal.register.open({
      loginReason: I18n.t('javascript.login-reason.common-community-interaction'),
    });
  });

  const $response = $('#comments');

  $response.on('click', 'button.btn.comment__login__btn, button.comment__item__login', (e) => {
    e.preventDefault();
    ga('send', 'event', 'onboarding', 'comment-login');
    viddsee.ui.modal.register.open({
      callback: 'new_comment',
      loginReason: I18n.t('javascript.login-reason.common-community-interaction'),
    });
  });

  $response.on('click', '.comment__new__send', _addCommunityCommentComment);

  const $replies = $('div.comment-container');

  $replies.on('vs:app:community-response:comment:like', (e) => {
    _voteHandler(e);
  });

  $replies.on('vs:app:community-response:comment:load_more', (e) => {
    loadMoreReplies();
  });

  // Body - parentComment + response + replies
  const $body = $('div.response');

  $body.on('vs:app:community-response:comment:delete', (e, commentId) => {
    _deleteComment(e, commentId);
  });
};

const _addCommunityCommentComment = function _addCommunityCommentComment(e) {
  e.preventDefault();
  e.stopPropagation();
  const submitBtn = $(this);

  const l = Ladda.create(submitBtn[0]);
  l.start();

  const body = submitBtn.parents('#comments').find('.comment__new__textarea');
  const bodyText = body.val().trim();

  if (bodyText.length === 0) {
    body.focus();
    l.stop();
    l.remove();
    return;
  }

  const params = {
    body: bodyText,
    in_reply_to: parentCommentId,
  };

  webcall.community.postCommentComment({
    question_id: _question.id,
    params,
  }, (res, err) => {
    if (err) {
      // TODO: Use a centralized error logger
      // eslint-disable-next-line no-console
      console.error('Error', err);
    } else {
      // Update UI
      _updateAddCommunityCommentComment(res);
      l.stop();
      l.remove();
    }
  });
};

const _deleteComment = function _deleteComment(e, commentId) {
  const comment = $('#c-' + commentId);
  const body = comment.find('.comment__item__content');
  webcall.community.deleteComment({
    question_id: _question.id,
    comment_id: commentId,
  }, (res, err) => {
    comment.addClass('deleted');
    body.html(I18n.t('javascript.community.response.childComments.delete_confirmation'));
    comment.find('.comment__item__delete').hide();
    comment.find('.comment__item__recommend').hide();
    comment.trigger('vs:ui:community-response:comment:delete:toggle');
  });
};

const _updateAddCommunityCommentComment = function _updateAddCommunityCommentComment(reply) {
  const tplReplyContainer = _.template($('.tpl-comment-reply').html());
  reply.body = Autolinker.link(reply.body.replace(/(?:\r\n|\r|\n)/g, '<br />'));
  reply.created_at = moment(reply.created_at).fromNow();
  reply.likes = UIHelper.pluralizeLikes(reply.likes);

  $('.comment-content').prepend($(tplReplyContainer({
    comment: reply,
    admin: (me) ? me.admin_access : me,
    isLogin: loginController.checkLogin(),
    isDeletable: BrowserStorage.getItem('user_id') === reply.user.id.toString(),
    url: window.location.protocol + '//' + window.location.hostname + '/community/' + _question.slug + '/comment/' + reply.id,
  }))
    .hide()
    .fadeIn('slow'))
  ;
  $('textarea.comment__new__textarea').val('');
};

const _initLoadReplies = function _initLoadReplies() {
  $('#comments__see-more').trigger('vs:ui:community-response:comment:see_more:start');

  const tplReplyContainer = _.template($('.tpl-comment-reply').html());
  const perPage = (targetCommentPos >= 10) ? Math.ceil(targetCommentPos / DEFAULT_REPLY_PER_PAGE) * DEFAULT_REPLY_PER_PAGE : DEFAULT_REPLY_PER_PAGE;
  const $btnCommentsLoadMore = $('#comments__see-more');
  const replyHTMLArray = [];

  webcall.community.getCommentReplies({
    comment_id: parentCommentId,
    question_id: _question.id,
    params: {
      current_page: 0,
      per_page: perPage,
    },
  }, (response) => {
    for (const index in response.comments) {
      const reply = response.comments[index];
      reply.likes = UIHelper.pluralizeLikes(reply.likes);
      reply.body = Autolinker.link(reply.body.replace(/(?:\r\n|\r|\n)/g, '<br />'));
      reply.created_at = moment(reply.created_at).fromNow();
      replyHTMLArray.push(tplReplyContainer({
        comment: reply,
        admin: (me) ? me.admin_access : me,
        isLogin: loginController.checkLogin(),
        isDeletable: BrowserStorage.getItem('user_id') === reply.user.id.toString(),
        url: window.location.protocol + '//' + window.location.hostname + '/community/' + _question.slug + '/comment/' + reply.id,
      }));
    }
    $('.comment-content').append(replyHTMLArray.reduce((prev, curr, idx, arr) => prev + curr, ''));

    twemoji.parse(document.getElementById('comment-content'));
    // dotdotdot ...
    $('.text-wrap-see-more').dotdotdot({
      after: $('<a href="#" class="comment__item__content__see-more">See more</a>'),
    });

    // Hide share and flag buttons
    $('div.comment__item .comment__item__actions').hide();

    const newCurrentPage = Math.max(Math.floor(targetCommentPos / DEFAULT_REPLY_PER_PAGE), 0);
    $btnCommentsLoadMore.data('current-page', newCurrentPage);
    if (response.current_page + 1 < response.total_pages) {
      $btnCommentsLoadMore.show();
    } else {
      $btnCommentsLoadMore.trigger('vs:ui:community-response:comment:see_more:waypoints:destroy');
    }

    $('#comments__see-more').trigger('vs:ui:community-response:comment:see_more:stop');
    if (targetCommentId !== -1) UIHelper.scrollTo('#c-' + targetCommentId.toString());
  });
};

const loadMoreReplies = function loadMoreReplies() {
  $('#comments__see-more').trigger('vs:ui:community-response:comment:see_more:start');

  const tplReplyContainer = _.template($('.tpl-comment-reply').html());
  const $btnCommentsLoadMore = $('#comments__see-more');
  const currentPage = $btnCommentsLoadMore.data('current-page');
  const replyHTMLArray = [];

  webcall.community.getCommentReplies({
    comment_id: parentCommentId,
    question_id: _question.id,
    params: {
      current_page: currentPage + 1,
      per_page: DEFAULT_REPLY_PER_PAGE,
    },
  }, (response) => {
    for (const index in response.comments) {
      const reply = response.comments[index];
      reply.likes = UIHelper.pluralizeLikes(reply.likes);
      reply.body = Autolinker.link(reply.body.replace(/(?:\r\n|\r|\n)/g, '<br />'));
      reply.created_at = moment(reply.created_at).fromNow();

      replyHTMLArray.push(tplReplyContainer({
        comment: reply,
        admin: (me) ? me.admin_access : me,
        isLogin: loginController.checkLogin(),
        isDeletable: BrowserStorage.getItem('user_id') === reply.user.id.toString(),
        url: window.location.protocol + '//' + window.location.hostname + '/community/question/' + _question.id + '/comment/' + reply.id,
      }));
    }
    $('.comment-content div.comment:last-child').after(replyHTMLArray.reduce((prev, curr, idx, arr) => prev + curr, ''));

    twemoji.parse(document.getElementById('comment-content'));
    // dotdotdot ...
    $('.text-wrap-see-more').dotdotdot({
      after: $('<a href="#" class="comment__item__content__see-more">See more</a>'),
    });

    const loc = window.location.hash.substr(1);
    if (loc) {
      UIHelper.scrollTo(loc);
    }

    // Hide share and flag buttons
    $('div.comment__item .comment__item__actions').hide();

    $btnCommentsLoadMore.data('current-page', currentPage + 1);
    if (response.current_page + 1 < Math.ceil(response.total_pages)) {
      $btnCommentsLoadMore.show();
    } else {
      $btnCommentsLoadMore.trigger('vs:ui:community-response:comment:see_more:waypoints:destroy');
    }

    $('#comments__see-more').trigger('vs:ui:community-response:comment:see_more:stop');
  });
};

const _voteHandler = function _voteHandler(e) {
  const $likeBtn = $(e.target);
  const commentId = $likeBtn.data('id');

  webcall.community.getCommentVote({
    comment_id: commentId,
    question_id: _question.id,
  }, (response) => {
    $likeBtn.html('<i class=\'fa fa-thumbs-o-up\'></i> ' + UIHelper.pluralizeLikes(response.likes));
    if (response.user_vote) {
      $likeBtn.addClass('selected');
    } else {
      $likeBtn.removeClass('selected');
    }
  });
};

const CommunityResponse = {
  init() {
    if (!_preInit()) return;

    UICommunityResponse.registerEventBindings();
    _initPageData(() => {
      // Dependencies on me being initialized goes here
      _initLoadReplies();
    });
    _bindUIActions();

    // FIXME: You know you should clean this up right?
    // Trigger UI updates if the user is or NOT logged in
    loginController.checkLoginStatus((status) => {
      if (status === 'signed_in') {
        $('.response__content__like--login')
          .addClass('response__content__like')
          .removeClass('response__content__like--login')
        ;
      }
    });
  },
};

export default CommunityResponse;
